import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'widget-loader',
  templateUrl: './widget-loader.component.html',
  styleUrls: ['./widget-loader.component.scss']
})
export class WidgetLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
